export const INPUT_TYPE_DEBOUNCE = 400;
